import ApiCore from './api-core'
import { DRIVER } from '@/constants/api-types'

export default class LoadCar extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/order/car`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  currentOrder(filter, showProgress) {
    return this.request({
      action: 'currentOrder',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  info(id, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'GET',
      showProgress
    })
  }

  initiate(id, model, showProgress) {
    return this.request({
      action: `${id}/initiate`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  reachOrigin(id, model, showProgress) {
    return this.request({
      action: `${id}/reachOrigin`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  loading(id, model, showProgress) {
    return this.request({
      action: `${id}/loading`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  reachDestination(id, model, showProgress, destinationId) {
    return this.request({
      action: `${id}/reachDestination`,
      method: 'PATCH',
      params: { destinationId },
      body: model,
      showProgress
    })
  }

  discharge(id, model, showProgress) {
    return this.request({
      action: `${id}/discharge`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  deliveryCode(id, showProgress) {
    return this.request({
      action: `${id}/deliveryCode`,
      method: 'PATCH',
      showProgress
    })
  }

  pendingList(filter, showProgress) {
    return this.request({
      action: 'list/pending',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  acceptTrash(id, model, showProgress) {
    return this.request({
      action: `${id}/accept`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
